// 受託仕入先情報の照会と entrydata への反映をまとめる。
// 本文は HinbanMaster.js から移設したもの。

export function createJyutakuSupplierService(deps) {
    const {
        DicVal,
        assignEntryDataCurrent,
        dispatch,
        entrydata,
        entrydataRef,
        entryrerender,
        fnc,
        isEmpty,
        lastJyutakuSupplierCodeRef,
        protectHbSeasonCommit,
        syncHinbanGenkaCurrencyState,
        syncHinbanGenkaPatternByEntry
    } = deps;

    function setJyutakuSupplierInfoOnEntryData(targetData, data) {
        if (isEmpty(targetData)) return false;
        let changed = false;
        const mappings = [
            ["PDT_SIREJYUTAKUKBN", "PDT_SIREJYUTAKUKBN"],
            ["PDT_JYUTAKUPKAKERITU", "PDT_JYUTAKUPKAKERITU"],
            ["PDT_JYUTAKUBKAKERITU", "PDT_JYUTAKUBKAKERITU"]
        ];
        mappings.forEach(([targetKey, sourceKey]) => {
            const nextValue = String(DicVal(data, sourceKey, "")).trim();
            if (String(DicVal(targetData, targetKey, "")).trim() === nextValue) return;
            targetData[targetKey] = nextValue;
            changed = true;
        });
        return changed;
    }
    function loadJyutakuSupplierInfo(options) {
        const requestOptions = isEmpty(options) ? {} : options;
        const targetData = isEmpty(DicVal(requestOptions, "targetData", null))
            ? entrydataRef.current
            : DicVal(requestOptions, "targetData", null);
        if (isEmpty(targetData)) return;

        const supplierCode = String(DicVal(targetData, "PDT_JYUTAKUSIRECD", "")).trim();
        if (isEmpty(supplierCode)) {
            lastJyutakuSupplierCodeRef.current = "";
            const changed = setJyutakuSupplierInfoOnEntryData(targetData, {});
            if (!changed) return;
            assignEntryDataCurrent(protectHbSeasonCommit(targetData, "targetData"), "targetData");
            syncHinbanGenkaCurrencyState(entrydataRef.current, true);
            syncHinbanGenkaPatternByEntry(entrydataRef.current);
            dispatch(entrydata({ ...entrydataRef.current }));
            dispatch(entryrerender());
            return;
        }

        if (!DicVal(requestOptions, "force", false) && lastJyutakuSupplierCodeRef.current === supplierCode) {
            return;
        }
        lastJyutakuSupplierCodeRef.current = supplierCode;

        fnc.current.postaxios("hinbanmaster/GetJyutakuSupplierInfo",
            { PDT_JYUTAKUSIRECD: supplierCode },
            {
                onSuccess: function (data) {
                    const payload = String(DicVal(data.returnData, "Found", "false")).toLowerCase() === "true"
                        ? data.returnData
                        : {};
                    const changed = setJyutakuSupplierInfoOnEntryData(targetData, payload);
                    if (!changed) return;
                    assignEntryDataCurrent(protectHbSeasonCommit(targetData, "targetData"), "targetData");
                    syncHinbanGenkaCurrencyState(entrydataRef.current, true);
                    syncHinbanGenkaPatternByEntry(entrydataRef.current);
                    dispatch(entrydata({ ...entrydataRef.current }));
                    dispatch(entryrerender());
                },
                onError: function (data) {
                    lastJyutakuSupplierCodeRef.current = "";
                    if (!DicVal(requestOptions, "silent", true)) {
                        let msg = "受託仕入先情報の取得に失敗しました";
                        if (!isEmpty(data.errDescription)) msg = data.errDescription;
                        fnc.current.warnmsg(msg);
                    }
                }
            }, true
        );
    }

    return {
        setJyutakuSupplierInfoOnEntryData,
        loadJyutakuSupplierInfo
    };
}
